import DOMPurify from 'dompurify';

export function DomPurifySanitize(data: string) {
  if (typeof window !== 'undefined') {
    return DOMPurify.sanitize(data);
  }
  return data;
}

export const getEnvironment = (url = '') => ({
  isClient: typeof window !== 'undefined',
  isServer: typeof window === 'undefined',

  isLocal: url.includes('localhost'),
  isTest: url.includes('frontend'),
  isStg: url.includes('stg.occloud.io'),
  isEphemeral: url.includes('stg.us.occloud.io'),
  isGreen: url.includes('green.prod.us.occloud.io'),
  isProd: url.includes('oddschecker.com'),
});
